import { Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';
import { SelectorCountry } from '../models/selector-country.model';
import { GroupedResponseTwoLevels } from "../models/grouped-statistics-response.model";
import { SimpleStatisticsResponse } from "../models/simple-statistics-response.model";
import { StatisticsRequest } from '../models/statistics-request.model';
import { BehaviorSubject } from 'rxjs';

interface ExcelObject {
    xlsxFileName: string,
    dataRequest: StatisticsRequest,
    file: string,
    selectedData: GroupedResponseTwoLevels<SimpleStatisticsResponse>,
    csvReverseIndex: Map<string, number>,
    countries: Map<string, SelectorCountry>
}

@Injectable({
    providedIn: 'root'
})

export class WorkerService {
    private _isGeneratingFileSubject = new BehaviorSubject<boolean>(false);
    readonly isGeneratingFileSubject$ = this._isGeneratingFileSubject.asObservable();

    setGenerateStatus(status: boolean) {
        this._isGeneratingFileSubject.next(status);
    }

    async generateExcelFile(xlsxFileName: string, dataRequest: StatisticsRequest,
        file: string, selectedData: GroupedResponseTwoLevels<SimpleStatisticsResponse>,
        csvReverseIndex: Map<string, number>, countries: Map<string, SelectorCountry>) {

        const worker = new Worker(new URL('./../workers/app.worker', import.meta.url));
        worker.onmessage = ({ data }) => {
            FileSaver.saveAs(data, xlsxFileName);
            this.setGenerateStatus(false);
        };

        const excelObject: ExcelObject = {
            xlsxFileName: xlsxFileName,
            dataRequest: dataRequest,
            file: file,
            selectedData: selectedData,
            csvReverseIndex: csvReverseIndex,
            countries: countries
        };

        worker.postMessage(excelObject);
    }
}